export default () => ({
  root: {},
});
